// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  mainContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  titleText: {
    display: 'block',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    maxWidth: 310,
  },
  blueText: {
    color: GlobalStyles.color.COLOR_SECONDARY,
  },
  basketItemsContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 15,
    zIndex: 10,
  },
  alert: {
    width: '100%',
    padding: '10px 30px',
    backgroundColor: GlobalStyles.color.COLOR_YELLOW_SELECT,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
  },
  topContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '90%',
    marginTop: 30,
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down(800)]: {
      justifyContent: 'flex-start',
    },
    [theme.breakpoints.down(650)]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '90%',
      marginTop: 110,
    },
  },
  topLeftContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down(800)]: {
      marginRight: 20,
    },
    [theme.breakpoints.down(650)]: {
      width: '100%',
    },
  },
  buttonsCOntainer: {
    width: '100%',
    margin: '20px 0',
  },
});

export default styles;
